module.exports = __webpack_public_path__ + "img/home_four_008.80fc7d46.png";